import { ConnectedRouter } from 'connected-react-router';
import { useMemo } from 'react';
import { connect } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { O2AppUI, LayoutSkeleton } from '@o2/ui';
import { AppContent } from './AppContent';
import { persistor } from './helpers/store/configureStore';
import { AppState } from './helpers/store/models/AppState';
import { history } from './helpers/store/rootReducer';
import { isAppInitialized } from './saga/appHandlers/ducks';
import 'dayjs/locale/cs';

const App = ({ appInitialized }: StateToProps) => {
  const loader = useMemo(() => {
    return (
      <O2AppUI>
        <LayoutSkeleton />
      </O2AppUI>
    );
  }, []);

  return (
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>{appInitialized ? <AppContent /> : loader}</ConnectedRouter>
    </PersistGate>
  );
};

interface StateToProps {
  appInitialized?: boolean;
}

const mapStateToProps = (state: AppState): StateToProps => ({
  appInitialized: isAppInitialized(state),
});

export default connect(mapStateToProps, null)(App);
